import { Link } from 'react-router-dom';
import { default as SessionStep } from './SessionStep';
import { STEPS_CONFIG, ADDITIONAL_FORMS } from '../../../constants/steps';


const SessionProgress = ({ 
  activeStep, 
  isStepComplete, 
  isTerminating, 
  sessionId, 
  onOpenSafetyForm, 
  onOpenTerminationForm,
  steps,
  sessionData,
  onStepClick // New prop for step navigation
}) => {
  
  // Helper function to determine if a step can be clicked
  const canClickStep = (stepKey) => {
    const stepIndex = steps.indexOf(stepKey);
    const activeIndex = steps.indexOf(activeStep);
    
    // Can click if:
    // 1. It's the current step
    // 2. It's a previous step (always accessible)
    // 3. It's the next step and current step is complete
    return stepKey === activeStep || 
           stepIndex < activeIndex || 
           (stepIndex === activeIndex + 1 && isStepComplete(activeStep));
  };

  const handleStepClick = (stepKey) => {
    if (canClickStep(stepKey) && onStepClick) {
      onStepClick(stepKey);
    }
  };

  return (
    <div className="flex flex-col mb-8 bg-white rounded-lg shadow p-6">
      {/* Main Steps */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {steps.map((stepKey) => {
          const step = STEPS_CONFIG[stepKey];
          if (!step) return null;

          const clickable = canClickStep(stepKey);
          
          return (
            <div
              key={stepKey}
              className={`${clickable ? 'cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors' : ''}`}
              onClick={() => clickable && handleStepClick(stepKey)}
            >
              <SessionStep
                {...step}
                isActive={activeStep === stepKey}
                isCompleted={activeStep !== stepKey && isStepComplete(stepKey)}
                isClickable={clickable}
              />
            </div>
          );
        })}
      </div>

      {/* Progress indicator for multi-step sessions */}
      {steps.length > 1 && (
        <div className="mt-6">
          <div className="flex justify-between text-xs text-gray-500 mb-2">
            <span>Step {steps.indexOf(activeStep) + 1} of {steps.length}</span>
            <span>{Math.round(((steps.indexOf(activeStep) + 1) / steps.length) * 100)}% Complete</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className="bg-blue-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${((steps.indexOf(activeStep) + 1) / steps.length) * 100}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Additional Forms */}
      <div className="mt-6 pt-6 border-t">
        <p className="py-4 font-semibold text-gray-700">Additional Forms (Click when needed)</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Object.entries(ADDITIONAL_FORMS).map(([key, step]) => (
            <button
              key={key}
              onClick={() => {
                if (key === 'safety') {
                  onOpenSafetyForm();
                } else {
                  onOpenTerminationForm();
                }
              }}
              className="flex items-center p-4 border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 hover:border-gray-300 transition-all duration-200"
            >
              <step.icon className="w-5 h-5 text-gray-600 mr-3" />
              <div className="text-left">
                <h3 className="font-medium text-gray-900">{step.title}</h3>
                <p className="text-sm text-gray-500">{step.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SessionProgress;
// const SessionProgress = ({ activeStep, isStepComplete, isTerminating, sessionId , onOpenSafetyForm, onOpenTerminationForm}) => (
//   <div className="flex flex-col mb-8 bg-white rounded-lg shadow p-6">
//     {/* Main Steps */}
//     <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//       {Object.entries(STEPS_CONFIG)
        
//         .map(([key, step]) => (
//           <SessionStep
//             key={key}
//             {...step}
//             isActive={activeStep === key}
//             isCompleted={activeStep !== key && isStepComplete(key)}
//           />
//         ))}
//     </div>

//     {/* Additional Forms */}
//     <div className="mt-4">
//       <p className="py-4 font-semibold">Click on the form you require</p>
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {Object.entries(ADDITIONAL_FORMS).map(([key, step]) => (
//           <button
//           key={key}
//           onClick={() => {
//             if (key === 'safety') {
//               onOpenSafetyForm();
//             } else {
//               onOpenTerminationForm();
//             }
//           }}
//           // onClick={key === 'safety' ? onOpenSafetyForm : onOpenTerminationForm}
//           className="flex flex-col items-center p-4 border rounded-lg shadow hover:bg-gray-100 transition"
//         >
//           <step.icon className="w-4 h-4 text-gray-600" />
//           <h3 className="mt-2 font-semibold">{step.title}</h3>
//           <p className="text-sm text-gray-500">{step.description}</p>
//         </button>
//         ))}
//       </div>
//     </div>
//   </div>
// );

// export default SessionProgress;
